import { StatusEnum } from 'constants/status';

export const MessageStatusType = {
  SUCCESS: 'success',
  ERROR: 'error',
};

export const statusIconTypeMap = {
  [MessageStatusType.SUCCESS]: StatusEnum.SUCCESS,
  [MessageStatusType.ERROR]: StatusEnum.ERROR,
};
